module.exports = __webpack_public_path__ + "img/scj.f6b35cca.png";